export default {
  strings: {
    nav: {
      home: "Главная",
      services: "Услуги",
      personal: "Личная поддержка",
      about: "О нас",
      packages: "Пакеты",
      faq: "FAQ",
      contact: "Контакты",
      book: "Забронировать консультацию",
    },
    common: {
      book: "Забронировать консультацию",
      quote: "Запросить расчёт",
      viewServices: "Смотреть услуги",
    },
    whatsapp: {
      label: "Чат в WhatsApp",
      prefill: "Здравствуйте, VCK Business Lab! Хочу узнать больше о ваших услугах.",
    },
    footer: {
      tagline: "Первоклассная виртуальная поддержка современного бизнеса",
      blurb:
        "Надёжная, конфиденциальная и детальная виртуальная административная поддержка — на 100% удалённо для клиентов в Канаде, США, Европе и по всему миру.",
      explore: "Навигация",
      services: "Услуги",
      ownerLogin: "Вход для владельца",
      rights: "VCK Business Lab. Все права защищены.",
      virtual: "100% удалённо · Весь мир",
      quote: "Запросить расчёт",
    },
    cta: {
      overline: "Доверьте детали нам.",
      title: "Тратьте меньше времени на администрирование и больше — на развитие вашего бизнеса.",
      book: "Забронировать консультацию",
      quote: "Запросить расчёт",
    },
    home: {
      heroOverline: "VCK Business Lab · 100% удалённо · Весь мир",
      heroLine1: "Профессиональная виртуальная поддержка",
      heroLine2: "для бизнеса и повседневной жизни.",
      heroSub:
        "Административная, деловая и многоязычная поддержка для компаний, профессионалов, частных лиц и новоприбывших — на 100% удалённо в Канаде и по всему миру.",
      heroStats: [
        { stat: "100%", label: "Удалённая работа из любой точки" },
        { stat: "Весь мир", label: "Канада · США · Европа · далее" },
        { stat: "Бутик", label: "Конфиденциальная персональная поддержка" },
      ],
      extOverline: "Продолжение вашего бизнеса",
      extTitle: "Надёжная поддержка без найма штатного сотрудника.",
      extCopy:
        "VCK Business Lab работает как органичное продолжение вашего бизнеса — предоставляя надёжную, конфиденциальную и детальную административную поддержку без затрат и обязательств штатного сотрудника.",
      extPoints: [
        { title: "Надёжность", text: "Стабильная поддержка, на которую можно планировать." },
        { title: "Конфиденциальность", text: "Информация вашего бизнеса обрабатывается со строгой конфиденциальностью и разумными мерами защиты." },
        { title: "Внимание к деталям", text: "Каждая задача выполняется тщательно и на высоком уровне." },
      ],
      svcOverline: "Услуги",
      svcTitle: "Всё на вашем столе — деликатно решено.",
      svcCopy: "Наши направления поддержки — удалённо и адаптировано под ваш стиль работы и жизни.",
      svcViewAll: "Все услуги",
      svcViewDetails: "Подробнее",
      splitOverline: "Поддержка, созданная вокруг вас",
      splitTitle: "Два направления. Один стандарт заботы.",
      splitCopy: "Управляете бизнесом или строите новую жизнь — VCK встречает вас там, где вы есть.",
      splitBizTitle: "Бизнес-услуги",
      splitBizText:
        "Виртуальная административная, управленческая, многоязычная, документная, проектная и веб-поддержка для компаний, предпринимателей и профессионалов по всему миру.",
      splitBizPoints: ["Административная поддержка и поддержка руководителей", "Перевод и многоязычная коммуникация", "Документы, проекты и веб-сайты"],
      splitBizCta: "Смотреть бизнес-услуги",
      splitPerTitle: "Личная поддержка и поддержка новоприбывших",
      splitPerText:
        "Внимательная, конфиденциальная поддержка для частных лиц, семей и новоприбывших в Канаду — повседневные задачи, решённые на вашем языке.",
      splitPerPoints: ["Языковая помощь и помощь в общении", "Помощь со страхованием, банками и коммунальными услугами", "Жильё, школы и повседневное администрирование"],
      splitPerCta: "Смотреть личную поддержку",
      stepsOverline: "Как это работает",
      stepsTitle: "От первого звонка до полного фокуса — четыре шага.",
      whyOverline: "Почему VCK",
      whyTitle: "Стандарт, которого заслуживает ваш бизнес.",
      whyCopy: "Больше, чем выполнение задач, — профессиональное партнёрство, построенное на доверии, точности и конфиденциальности.",
      whoOverline: "С кем мы работаем",
      whoTitle: "Нас выбирают те, кто двигает бизнес вперёд.",
      testOverline: "Отзывы",
      testTitle: "Истории клиентов.",
      testLaunch: "Сейчас мы приветствуем наших первых пилотных клиентов. Отзывы клиентов и кейсы будут добавляться по мере роста VCK.",
      packOverline: "Постоянные планы поддержки",
      packTitle: "Ежемесячная поддержка, адаптированная под вас.",
      packCopy:
        "Гибкие ежемесячные пакеты в USD — никаких жёстких подписок. Финальная стоимость согласовывается после короткой консультации.",
      packViewAll: "Смотреть пакеты",
      packIncluded: "Что включено",
      packGlobalTitle: "Global Priority",
      packGlobalText:
        "Международная, многоязычная, расширенная по времени или высокообъёмная поддержка — полностью индивидуальные ежемесячные договорённости с собственными процессами и льготными экстренными тарифами.",
      packGlobalBtn: "Запросить индивидуальный расчёт",
      faqOverline: "Частые вопросы",
      faqTitle: "Ответы — ещё до вопроса.",
      faqViewAll: "Все вопросы",
      loyaltyText:
        "Постоянные клиенты получают до 36 бесплатных часов поддержки, приоритетные преимущества и приветственный пакет VCK.",
      loyaltyCta: "Программа лояльности",
    },
    services: {
      overline: "Услуги и цены",
      line1: "Услуги, созданные вокруг",
      line2: "вас.",
      intro:
        "От повседневного администрирования до многоязычной коммуникации и срочной международной поддержки — VCK Business Lab предоставляет гибкую многоязычную поддержку для бизнесов, профессионалов, новоприбывших, иностранных студентов и международных клиентов.",
      languages: "English | Українська | العربية | Other Languages",
      worldwide: "Клиенты по всему миру • 100% удалённо",
      showLess: "Свернуть",
      pricing: "Цены",
      plansOverline: "Постоянные планы поддержки",
      plansTitle: "Ежемесячная поддержка, адаптированная под вас.",
      plansCopy: "Это не жёсткие подписки — каждый план можно адаптировать под ваши часы, услуги, языки и приоритеты.",
      disOverline: "Гибкие цены для каждого бизнеса",
      disQuote:
        "«Указанные цены — стартовые тарифы в USD. Финальная стоимость зависит от сложности, языковой комбинации, срочности, необходимой экспертизы, объёма и требований к услуге. Доступны ежемесячные пакеты и проектное ценообразование.»",
      disNote: "Долгосрочные обязательства не требуются, если иное не предусмотрено сервисным контрактом.",
    },
    packages: {
      availabilityNote: "Указанные цены являются начальными, а все услуги предоставляются при наличии возможности. Объём, результаты, сроки, стоимость и правки подтверждаются в письменном расчёте или соглашении.",
      overline: "Пакеты",
      line1: "Поддержка, масштабируемая",
      line2: "под вашу нагрузку.",
      intro:
        "Каждое сотрудничество начинается со стартового тарифа, который уточняется после короткой консультации, — вы платите только за нужную поддержку. Без принуждения к покупке: начните с расчёта.",
      note: "Это не жёсткие подписки — каждый план можно адаптировать под ваши часы, услуги, языки и приоритеты.",
      mostRequested: "Самый популярный",
      startingFrom: "Начиная от",
      tailored: "Индивидуально",
      requestQuote: "Запросить расчёт",
      quoteNote: "Без онлайн-оплаты на сайте — после подтверждения объёма и стоимости мы отправляем вам защищённую платёжную ссылку напрямую.",
      compareOverline: "Сравнение пакетов",
      compareTitle: "Найдите свой вариант с первого взгляда.",
      compareIncluded: "Включено",
      disOverline: "Гибкие цены для каждого бизнеса",
      disQuote:
        "«Указанные цены — стартовые тарифы в USD. Финальная стоимость зависит от сложности, языковой комбинации, срочности, необходимой экспертизы, объёма и требований к услуге. Доступны ежемесячные пакеты и проектное ценообразование.»",
      disNote: "Долгосрочные обязательства не требуются, если иное не предусмотрено сервисным контрактом.",
      loyaltyOverline: "Программа лояльности",
      loyaltyTitle: "Больше поддержки. Больше ценности. Больше причин остаться.",
      loyaltyIntro:
        "В VCK Business Lab мы ценим долгосрочные партнёрства. Выбирая постоянный план поддержки, вы получаете бесплатные часы, приоритетные преимущества и приветственный подарок VCK.",
      bestValue: "Лучшая выгода",
      welcomeOverline: "Маленький подарок от VCK",
      welcomeTitle: "Каждый новый постоянный клиент должен почувствовать себя желанным.",
      welcomeText:
        "Клиенты, соответствующие условиям, получают бесплатный приветственный пакет VCK — с заботой подготовленный как благодарность за выбор нас как партнёра по поддержке бизнеса.",
      welcomeNote: "Без какой-либо доплаты — просто наш способ сказать: добро пожаловать в VCK.",
      welcomeInclude: "Ваш пакет может включать",
      welcomeItems: ["Премиальные настольные аксессуары", "Бизнес-аксессуары", "Брендированные вещи VCK", "Персональный приветственный подарок"],
      bonusOverline: "Ваши бонусные часы — ваш выбор",
      bonusTitle: "Используйте дополнительные часы тогда, когда нужна ещё одна пара рук.",
      bonusText: "Бесплатные часы можно использовать для подходящих услуг VCK, включая:",
      builtOverline: "Создано вокруг вашего бизнеса",
      builtTitle: "Не знаете, какой пакет подойдёт именно вам?",
      builtText: "Мы создадим план поддержки под вашу нагрузку, языки, часовой пояс и потребности бизнеса.",
      builtBook: "Бесплатная консультация",
      builtOr: "или",
      builtQuote: "Персональный расчёт",
      welcomeLine: "Добро пожаловать в VCK Business Lab",
      welcomeTagline: "Глобальная поддержка · Многоязычная экспертиза · Бизнес-партнёр, на которого можно положиться",
      referOverline: "Реферальная программа",
      referTitle: "Делитесь VCK. Получайте бесплатную поддержку.",
      referIntro:
        "Нравится работать с VCK Business Lab? Порекомендуйте нас другому бизнесу и получите бесплатные часы поддержки, когда он станет клиентом VCK.",
      referSteps: [
        {
          title: "Порекомендуйте бизнес",
          text: "Познакомьте VCK Business Lab с бизнесом, профессионалом или предпринимателем, которому будут полезны наши услуги.",
        },
        { title: "Они присоединяются к VCK", text: "Ваш реферал подписывает подходящий пакет обязательств VCK." },
        {
          title: "Вы получаете бесплатные часы",
          text: "Как только их соглашение начинается, бесплатные часы поддержки добавляются на ваш счёт как наша благодарность.",
        },
      ],
      referRewardsTitle: "Реферальные вознаграждения",
      referTiers: [
        { plan: "Реферал подписывает пакет на 1 месяц", hours: "Получите 2 бесплатных часа" },
        { plan: "Реферал подписывает пакет на 3 месяца", hours: "Получите 5 бесплатных часов" },
        { plan: "Реферал подписывает пакет на 6 месяцев", hours: "Получите 10 бесплатных часов" },
        { plan: "Реферал подписывает пакет на 12 месяцев", hours: "Получите 20 бесплатных часов" },
      ],
      referMoreTitle: "Рекомендуйте больше. Получайте больше.",
      referMoreText:
        "Не останавливайтесь на одной рекомендации. Рекомендуйте несколько бизнесов и продолжайте зарабатывать бесплатные часы поддержки VCK, когда подходящие рефералы становятся клиентами.",
      referMilestones: [
        { count: "3 успешные рекомендации", reward: "Получите дополнительно 5 бонусных часов" },
        { count: "5 успешных рекомендаций", reward: "Получите дополнительно 10 бонусных часов" },
        { count: "10 успешных рекомендаций", reward: "Специальная награда лояльности VCK плюс дополнительная бесплатная поддержка" },
      ],
      referThanksOverline: "Благодарность за то, что растёте с нами",
      referThanksText:
        "Наш бизнес растёт благодаря отношениям, и мы хотим, чтобы наши клиенты получали выгоду, представляя VCK другим. Ваши бесплатные реферальные часы можно использовать для подходящих услуг, таких как:",
      referServices: [
        "Виртуальная административная поддержка",
        "Поддержка руководителей",
        "Многоязычная бизнес-поддержка",
        "Документные и проектные услуги",
        "Переводческие услуги",
        "Другие подходящие услуги VCK",
      ],
      referCtaTitle: "Знаете бизнес, которому пригодится VCK?",
      referCtaText: "Помогите другому бизнесу открыть надёжную глобальную поддержку — и получите дополнительные часы VCK от нас.",
      referCtaBtn: "Порекомендовать бизнес",
    },
    about: {
      overline: "О VCK",
      line1: "Бутик-партнёр для работы,",
      line2: "стоящей за вашей работой.",
      intro:
        "VCK Business Lab создана, чтобы предоставлять бизнесам и профессионалам надёжную, организованную и высококачественную виртуальную административную поддержку — с заботой бутик-компании, а не дистанцией крупной корпорации.",
      storyOverline: "Почему мы существуем",
      storyTitle: "Созданы, чтобы вернуть вам ваше время.",
      storyP1:
        "Рутинная административная работа незаметно поглощает самые ценные часы. VCK Business Lab существует, чтобы снять этот груз с вашего стола — упрощая бизнес-операции гибкой профессиональной поддержкой без затрат и обязательств дополнительного штатного сотрудника.",
      storyP2:
        "Профессионализм, организованность, коммуникация, конфиденциальность и внимание к деталям — не маркетинговые слова, а рабочий стандарт каждого ящика, документа и встречи.",
      manOverline: "Наши принципы",
      manTitle: "Три обязательства, которые мы соблюдаем ежедневно.",
      globalOverline: "Глобальный охват",
      globalTitle: "Где бы вы ни вели бизнес — мы рядом.",
      globalCopy: "Все услуги предоставляются на 100% удалённо, поэтому VCK поддерживает клиентов бесшовно через часовые пояса и границы.",
      regions: ["Канада", "Соединённые Штаты", "Европа", "Международно"],
      valuesOverline: "Ключевые ценности",
      valuesTitle: "Чего ожидать — каждый раз.",
      whoOverline: "С кем мы работаем",
      whoTitle: "Создано для занятых людей и растущих бизнесов.",
    },
    faqPage: {
      overline: "FAQ",
      line1: "Ответы —",
      line2: "ещё до вопроса.",
      intro: "Вопросы, которые клиенты задают чаще всего о работе с VCK Business Lab. Если вашего здесь нет — мы в одном сообщении.",
      calloutOverline: "Остались вопросы?",
      calloutTitle: "Обсудим — без обязательств.",
      calloutText: "Бесплатная ознакомительная консультация — самый простой способ получить ответы именно для вашего бизнеса.",
      calloutBtn: "Бесплатная консультация",
    },
    contact: {
      overline: "Контакты",
      line1: "Поговорим о",
      line2: "вашей нагрузке.",
      intro: "Расскажите, что вы хотите снять со своего стола. На каждое обращение мы отвечаем лично в течение одного рабочего дня.",
      consultTitle: "Бесплатная консультация",
      consultText:
        "Запланируйте бесплатную ознакомительную консультацию, чтобы обсудить потребности вашего бизнеса, — без обязательств и давления. Мы посоветуем тип и уровень поддержки, который подойдёт именно вам.",
      consultPoints: [
        "Ознакомительный звонок в удобное для вас время",
        "Индивидуальная рекомендация под вашу нагрузку",
        "Никаких обязательств продолжать",
      ],
      consultBtn: "Бесплатная консультация",
      consultNote:
        "Все услуги предоставляются на 100% удалённо. Обращения международных клиентов — из Канады, США, Европы и других стран — всегда приветствуются.",
      trackLabel: "Я обращаюсь как",
      trackBusiness: "Бизнес",
      trackPersonal: "Частное лицо / новоприбывший",
      trackRequired: "Пожалуйста, укажите, обращаетесь ли вы как бизнес или как частное лицо.",
      formTitle: "Отправить запрос",
      formSub: "Запросите расчёт или задайте вопрос — остальное мы возьмём на себя.",
      name: "Имя",
      company: "Компания",
      email: "Электронная почта",
      phone: "Телефон",
      country: "Страна",
      support: "Тип необходимой поддержки",
      hours: "Примерное количество часов в неделю",
      preferred: "Предпочтительный способ связи",
      description: "Описание проекта",
      optional: "— необязательно",
      phName: "Ваше полное имя",
      phCompany: "Компания или должность",
      phEmail: "vy@company.com",
      phPhone: "+7 ___ ___ __ __",
      phCountry: "Где вы находитесь",
      phDescription: "Расскажите о задачах или проектах, с которыми нужна поддержка…",
      selectService: "Выберите услугу",
      selectHours: "Выберите примерный объём",
      selectPreferred: "Как с вами связаться?",
      freeConsultation: "Бесплатная консультация",
      customProject: "Индивидуальный проект",
      notSure: "Пока не знаю",
      hoursOptions: ["1–5 часов", "5–10 часов", "10–20 часов", "20+ часов", "Разовый проект", "Пока не знаю"],
      contactOptions: ["Электронная почта", "Телефон", "Видеозвонок"],
      planPrefill: "Я хотел(а) бы запросить расчёт для пакета {name}.",
      referralPrefill: "Я хочу порекомендовать бизнес компании VCK Business Lab.",
      submit: "Отправить запрос",
      sending: "Отправляем…",
      successTitle: "Спасибо — ваш запрос получен.",
      successText: "Мы ответим в течение одного рабочего дня. Письмо-подтверждение уже направляется к вам.",
      errorTitle: "Что-то пошло не так при отправке.",
      errorText: "Пожалуйста, попробуйте ещё раз чуть позже.",
    },
    personal: {
      overline: "Личная поддержка и поддержка новоприбывших",
      line1: "Повседневная поддержка для",
      line2: "жизни в новой стране.",
      intro:
        "Переезд в новую страну — или просто насыщенная личная жизнь — это письма, звонки, формы и встречи, часто на языке, который не является родным. VCK Business Lab предлагает внимательную, конфиденциальную виртуальную поддержку для частных лиц, семей и новоприбывших в Канаду.",
      languages: "English | Українська | العربية",
      worldwide: "Частные лица и семьи по всему миру • 100% удалённо",
      whoOverline: "Для кого это",
      whoTitle: "Поддержка для моментов, которые важны.",
      whoList: ["Новоприбывшие в Канаду", "Частные лица и семьи", "Пожилые люди", "Студенты", "Занятые профессионалы", "Все, кто ограниченно владеет английским"],
      svcOverline: "Как мы помогаем",
      svcTitle: "Личная поддержка — на вашем языке.",
      svcCopy: "Поддержка в повседневных задачах адаптации и организации — удалённо, терпеливо и конфиденциально.",
      services: [
        {
          title: "Языковая помощь",
          text: "Повседневные письма, электронные письма, формы и телефонные звонки — понятные и обработанные на вашем языке.",
          items: ["Разъяснение официальных и электронных писем", "Помощь в заполнении повседневных форм", "Поддержка телефонных звонков на вашем языке", "Повседневный (несертифицированный) перевод"],
        },
        {
          title: "Общение со страховыми и банками",
          text: "Чёткое, уверенное общение с банками, страховыми и поставщиками услуг.",
          items: ["Подготовка к звонкам в банк и страховую", "Разъяснение переписки и выписок", "Запись на встречи", "Письма-напоминания от вашего имени"],
        },
        {
          title: "Коммунальные услуги и счета",
          text: "Подключение услуг и контроль ежемесячных обязательств.",
          items: ["Оформление интернета, телефона и коммунальных услуг", "Разъяснение ежемесячных счетов", "Организация сервисных визитов", "Сравнение тарифных планов"],
        },
        {
          title: "Поддержка с жильём",
          text: "Спокойная, организованная помощь в процессе аренды.",
          items: ["Общение с арендодателями и управляющими компаниями", "Планирование просмотров жилья", "Разъяснение арендной переписки", "Чек-листы заселения и выселения"],
        },
        {
          title: "Школы и семья",
          text: "Поддержка повседневной координации вашей семьи.",
          items: ["Поддержка регистрации в школе", "Общение с учителями", "Формы для общественных программ", "Планирование детских занятий"],
        },
        {
          title: "Повседневное администрирование",
          text: "Мелкие задачи, которые тихо накапливаются, — решены.",
          items: ["Запись на приёмы и напоминания", "Организация личных документов", "Форматирование резюме и сопроводительных писем", "Управление календарём и расписанием"],
        },
      ],
      stepsOverline: "Как это работает",
      stepsTitle: "Просто — с первого сообщения.",
      steps: [
        { title: "Расскажите нам", text: "Поделитесь, с чем нужна помощь, — на родном языке, в сообщении или на бесплатной консультации." },
        { title: "Согласуем", text: "Мы подтверждаем объём и чёткую стартовую цену до начала любой работы." },
        { title: "Мы всё берём на себя", text: "Звонки, формы, письма и организация — терпеливо и конфиденциально." },
        { title: "Вы в курсе", text: "Чёткие обновления на вашем языке на каждом шаге." },
      ],
      disOverline: "Важно знать",
      disTitle: "Чёткие границы — осознанно.",
      disIntro:
        "VCK Business Lab предоставляет только административную, организационную и коммуникационную поддержку. Мы внимательно — и прозрачно — обозначаем то, чего не делаем.",
      disclaimers: [
        {
          title: "Никаких иммиграционных консультаций",
          text: "VCK Business Lab не предоставляет иммиграционных советов или консультаций и не готовит, не проверяет и не подаёт иммиграционные заявления. По иммиграционным вопросам обращайтесь к лицензированному канадскому иммиграционному консультанту (RCIC) или иммиграционному адвокату.",
        },
        {
          title: "Никаких юридических, финансовых или страховых советов",
          text: "Мы не предоставляем юридических, финансовых, страховых, налоговых или медицинских советов. Наша роль — коммуникация, организация и администрирование; решения всегда остаются за вами и вашими лицензированными специалистами.",
        },
        {
          title: "Только несертифицированный перевод",
          text: "Переводы в рамках личной поддержки — это общие, несертифицированные переводы для повседневного понимания. Мы не предоставляем присяжные, нотариально заверенные или судебно признанные переводы.",
        },
        {
          title: "Всегда правильный специалист",
          text: "Когда ваша ситуация требует лицензированного или регулируемого специалиста, мы всегда скажем об этом — и поможем найти правильного.",
        },
      ],
      partnerOverline: "Административная и языковая поддержка после прибытия в Канаде",
      partnerTitle: "Мы дополняем специалистов, которые помогают вам переехать.",
      partnerLine: "Вы помогаете своим клиентам попасть в Канаду. VCK Business Lab поддерживает их после прибытия.",
      partnerText:
        "VCK Business Lab работает рядом с иммиграционными консультантами, образовательными агентствами, колледжами, рекрутёрами и релокационными компаниями — и никогда вместо них.",
      partnerTypesLabel: "Кто рекомендует нас",
      partnerTypes: ["Иммиграционные консультанты (RCIC) и адвокаты", "Образовательные агентства и колледжи", "Рекрутёры и работодатели", "Релокационные компании", "Организации по адаптации и общины"],
      partnerWhyTitle: "Почему партнёры рекомендуют VCK",
      partnerWhy: [
        { title: "На их языке", text: "Клиенты получают поддержку на английском, украинском, арабском и других языках — ничего не теряется в переводе." },
        { title: "Чёткие границы", text: "Мы предоставляем только административную и языковую поддержку — никогда не даём иммиграционных или регулируемых советов, поэтому дополняем вашу работу, а не конкурируем с ней." },
        { title: "Быстро и надёжно", text: "Каждый рекомендованный клиент получает ответ в течение одного рабочего дня и бесплатную ознакомительную консультацию." },
        { title: "Конфиденциально по умолчанию", text: "Информация клиентов обрабатывается со строгой конфиденциальностью; при необходимости доступны соглашения о конфиденциальности." },
      ],
      partnerCta: "Обсудить партнёрство по рекомендациям",
      ctaOverline: "Вам не нужно разбираться со всем в одиночку.",
      ctaTitle: "Расскажите, что вам нужно, — на родном языке.",
      ctaText: "Бесплатная ознакомительная консультация — самый простой способ начать. Без обязательств и давления.",
    },
  },
  data: {
    services: [
      {
        title: "Виртуальная поддержка бизнеса и руководителей",
        tagline: "Профессиональная удалённая административная и управленческая поддержка для предпринимателей, руководителей, профессионалов и бизнесов по всему миру.",
        price: "От $30 USD/час",
        featured: ["Управление почтой и входящими", "Календарь и планирование", "Поддержка руководителей", "Координация встреч", "Администрирование проектов"],
        moreLabel: "Все услуги бизнес-поддержки",
        groups: [
          {
            heading: null,
            items: [
              "Управление электронной почтой и входящими",
              "Управление календарём",
              "Запись на встречи",
              "Организация совещаний",
              "Координация совещаний",
              "Управление календарём руководителя",
              "Общая поддержка виртуального ассистента",
              "Административная помощь",
              "Ввод данных",
              "Организация файлов",
              "Цифровое архивирование",
              "Обновление баз данных",
              "Онлайн-исследования",
              "Административные follow-up",
              "Отслеживание задач",
              "Ведение электронных таблиц",
              "Подготовка повестки дня",
              "Протоколы совещаний",
              "Заметки совещаний",
              "Контроль выполнения задач",
              "Профессиональная переписка",
              "Поиск вариантов поездок",
              "Организация поездок",
              "Координация мероприятий",
              "Администрирование проектов",
              "Координация заинтересованных сторон",
              "Организация бизнес-процессов",
              "Конфиденциальная административная поддержка",
              "Подготовка презентаций",
              "Внутренние трекеры",
              "Поддержка отчётности",
              "Временное административное покрытие",
              "Постоянная ежемесячная административная поддержка",
            ],
          },
        ],
        pricing: [
          { label: "Регулярная поддержка", value: "От $30/час" },
          { label: "Приоритетная поддержка", value: "От $45/час" },
          { label: "Месячные пакеты", value: "По индивидуальному расчёту" },
        ],
        cta: "Запросить расчёт",
      },
      {
        title: "Перевод и устный перевод",
        tagline: "Общий и деловой письменный и устный перевод для деловой коммуникации, встреч, документов, веб-сайтов, презентаций, взаимодействия с клиентами и других нерегулируемых целей.",
        price: "От $0.12 USD/слово",
        priceNote: "Устный перевод — от $40 USD/час",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["Деловой перевод", "Перевод документов", "Видеоперевод", "Телефонный перевод", "Локализация веб-сайтов"],
        moreLabel: "Все языковые услуги",
        groups: [
          {
            heading: "Перевод",
            items: [
              "Английский ↔ Украинский",
              "Другие языковые пары по запросу",
              "Английский ↔ Арабский",
              "Перевод деловых документов",
              "Перевод писем",
              "Перевод веб-сайтов",
              "Перевод презентаций",
              "Перевод маркетинговых материалов",
              "Перевод описаний продуктов",
              "Перевод клиентских коммуникаций",
              "Формы и анкеты",
              "Политики и процедуры",
              "Общая переписка",
              "Вычитка переведённых документов",
              "Редактирование переводов",
              "Локализация",
              "Ревизия машинного перевода",
              "Срочный деловой перевод",
              "Перевод в нерабочее время",
            ],
          },
          {
            heading: "Устный перевод",
            items: [
              "Дистанционный устный перевод",
              "Телефонный перевод",
              "Видеоперевод",
              "Перевод деловых встреч",
              "Перевод на приёмах и встречах",
              "Перевод клиентского сервиса",
              "Общественный устный перевод",
              "Запланированный устный перевод",
              "Срочный деловой устный перевод",
              "Устный перевод в нерабочее время",
            ],
          },
        ],
        pricing: [
          { label: "Стандартный перевод", value: "От $0.12/слово" },
          { label: "Индивидуальные бизнес-проекты", value: "По запросу" },
          { label: "Срочный перевод за 24 часа", value: "Стандартный тариф + 35%" },
          { label: "Менее 6 часов", value: "Стандартный тариф + 50%" },
          { label: "Срочный деловой перевод", value: "Индивидуальный расчёт" },
          { label: "Плановый деловой устный перевод", value: "От $40/час" },
          { label: "Приоритетный деловой устный перевод", value: "От $55/час" },
          { label: "Деловой устный перевод в нерабочее время", value: "От $65/час" },
        ],
        note: "VCK Business Lab не представляет свои стандартные услуги письменного и устного перевода как сертифицированные, присяжные, судебно-сертифицированные, юридические или официально аккредитованные, если это прямо не указано для конкретного проекта и не выполняется соответствующим квалифицированным специалистом.",
        cta: "Расчёт языковых услуг",
      },
      {
        title: "Многоязычная поддержка клиентов",
        tagline: "Многоязычная клиентская и административная поддержка, помогающая бизнесам профессионально общаться с клиентами на разных языках и в разных часовых поясах.",
        price: "От $35 USD/час",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["Многоязычная поддержка клиентов", "Follow-up клиентов", "Запись на приём", "Email-коммуникация", "Координация международных клиентов"],
        moreLabel: "Все многоязычные услуги",
        groups: [
          {
            heading: null,
            items: [
              "Многоязычная email-переписка",
              "Поддержка клиентов по email",
              "Коммуникация с клиентами",
              "Follow-up клиентов",
              "Планирование встреч",
              "Напоминания о встречах",
              "Обновление данных клиентов",
              "Онбординг клиентов",
              "Многоязычная административная поддержка",
              "Межкультурная деловая коммуникация",
              "Координация международных клиентов",
              "Поддержка в живом чате",
              "Клиентский сервис",
              "Поддержка FAQ",
              "Обновление CRM",
              "Ведение баз данных",
              "Координация услуг",
              "Follow-up заказов",
              "Приём жалоб и обращений",
              "Координация эскалаций",
              "Многоязычная деловая переписка",
              "Подготовка многоязычных документов",
              "Координация между часовыми поясами",
            ],
          },
        ],
        pricing: [
          { label: "Стандартная многоязычная поддержка", value: "От $35/час" },
          { label: "Приоритетная поддержка", value: "От $50/час" },
          { label: "Постоянная ежемесячная поддержка", value: "Индивидуальный пакет" },
        ],
        cta: "Сформировать индивидуальный пакет",
      },
      {
        title: "Документы, офис и проектные услуги",
        tagline: "Профессиональная подготовка, форматирование и организация документов, исследования и проектная поддержка для бизнесов и профессионалов.",
        price: "От $30 USD/час",
        featured: ["Форматирование Word и PDF", "Excel и трекеры", "Презентации", "Деловые документы", "Исследования и проектная поддержка"],
        moreLabel: "Все услуги по документам",
        groups: [
          {
            heading: "Документы",
            items: [
              "Форматирование Microsoft Word",
              "Подготовка PDF",
              "Форматирование PDF",
              "Формы",
              "Заполняемые документы",
              "Бизнес-шаблоны",
              "Профессиональные письма",
              "Отчёты",
              "Пакеты материалов для совещаний",
              "Форматирование резюме",
              "Форматирование сопроводительных писем",
              "Вычитка",
              "Чистка документов",
              "Редизайн документов",
              "Конвертация файлов",
              "Цифровое архивирование",
              "Организация документов",
            ],
          },
          {
            heading: "Таблицы",
            items: ["Таблицы Excel", "Трекеры", "Организация данных", "Трекеры расходов", "Трекеры инвойсов", "Бюджетные трекеры", "Списки контактов", "Проектные трекеры", "Трекеры дедлайнов"],
          },
          {
            heading: "Презентации и дизайн",
            items: ["Презентации PowerPoint", "Форматирование презентаций", "Бизнес-материалы в Canva", "Бизнес-флаеры", "Базовые брошюры", "Графика для соцсетей", "Профессиональные шаблоны"],
          },
          {
            heading: "Проектная и исследовательская поддержка",
            items: ["Маркетинговые исследования", "Анализ конкурентов", "Исследование поставщиков", "Исследование продуктов", "Онлайн-исследования", "Сбор данных", "Сравнительные таблицы", "Формирование списков контактов", "Администрирование проектов", "Контроль дедлайнов", "Координация follow-up", "Резюме исследований"],
          },
        ],
        pricing: [
          { label: "Почасовые проекты", value: "От $30/час" },
          { label: "Документы с фиксированной ценой", value: "По индивидуальному расчёту" },
          { label: "Крупные проекты", value: "Индивидуальный расчёт" },
        ],
        cta: "Запросить расчёт проекта",
      },
      {
        title: "Создание и поддержка веб-сайтов",
        tagline:
          "Профессиональные веб-сайты для современного бизнеса — мы можем просто разработать и создать его для вас или поддерживать и обновлять его долгосрочно в рамках ежемесячного пакета поддержки.",
        price: "От $40 USD/час",
        priceNote: "Разовая разработка — по индивидуальному расчёту",
        featured: ["Бизнес-сайты", "Целевые страницы", "Редизайн сайта", "Настройка интернет-магазина", "Постоянное обслуживание"],
        moreLabel: "Все веб-услуги",
        groups: [
          {
            heading: "Дизайн и разработка — разовые проекты",
            items: [
              "Дизайн и создание бизнес-сайта",
              "Создание целевых страниц",
              "Редизайн и обновление сайта",
              "Мобильные адаптивные макеты",
              "Настройка интернет-магазина / электронной коммерции",
              "Настройка контактных форм и форм бронирования",
              "Многоязычная настройка сайта",
              "Страницы портфолио и галереи",
              "Блог и контентные разделы",
              "Страницы меню, прайс-листов и каталогов",
            ],
          },
          {
            heading: "Постоянная поддержка — с любым ежемесячным пакетом",
            items: [
              "Обновление и изменение контента",
              "Обновление плагинов, тем и платформы",
              "Регулярное техническое обслуживание сайта",
              "Резервное копирование и проверки безопасности",
              "Координация домена и хостинга",
              "Базовая настройка SEO",
              "Аналитика и проверка производительности",
              "Устранение неполадок сайта",
            ],
          },
        ],
        pricing: [
          { label: "Обновления и поддержка сайта", value: "От $40/час" },
          { label: "Разовая разработка сайта", value: "По запросу" },
          { label: "Постоянное обслуживание с ежемесячным пакетом", value: "См. пакеты" },
        ],
        note: "Мы можем просто создать ваш веб-сайт как разовый проект — или дополнить его любым пакетом постоянной поддержки, и мы будем поддерживать его обновлённым, защищённым и развивающимся вместе с вашим бизнесом из месяца в месяц.",
        cta: "Обсудить ваш сайт",
      },
      {
        title: "Поддержка новоприбывших и иностранных студентов",
        tagline: "Административная и языковая поддержка после прибытия в Канаде.",
        price: "От $30 USD/час",
        meta: "English | Українська | العربية | Other Languages",
        featured: [
          "Запись на приёмы и планирование",
          "Помощь со звонками и письмами",
          "Общий перевод и устный перевод",
          "Практическая поддержка после прибытия",
        ],
        moreLabel: "Подробнее",
        groups: [
          {
            heading: "Что это включает",
            items: [
              "Практическая многоязычная административная и языковая поддержка для новоприбывших, иностранных студентов и лиц с ограниченным знанием английского, осваивающих повседневную жизнь в Канаде.",
            ],
          },
          {
            heading: "Повседневная координация",
            items: [
              "Запись на приёмы и планирование",
              "Помощь с телефонными звонками и электронными письмами",
              "Общение с канадскими компаниями и поставщиками услуг",
              "Напоминания и общая координация",
            ],
          },
          {
            heading: "Язык и документы",
            items: [
              "Помощь в понимании общей переписки и повседневных документов",
              "Общий перевод и устный перевод",
              "Многоязычная поддержка в повседневных административных вопросах",
            ],
          },
          {
            heading: "Адаптация на месте",
            items: [
              "Помощь в общении со школами, колледжами, работодателями и другими организациями",
              "Общая административная помощь",
              "Помощь в поиске общедоступных услуг и ресурсов",
              "Практическая поддержка после прибытия",
            ],
          },
        ],
        pricing: [
          { label: "Почасовая поддержка", value: "От $30/час" },
          { label: "Приоритетные запросы", value: "От $45/час" },
          { label: "Постоянная поддержка", value: "Индивидуальный расчёт" },
        ],
        note: "Важно: VCK Business Lab предоставляет только общую административную, языковую и практическую поддержку. Мы не предоставляем иммиграционные, гражданские, юридические, налоговые, финансовые, медицинские, трудовые, образовательные или иные регулируемые профессиональные советы или представительство. Если требуется помощь регулируемого специалиста, клиентам следует обратиться к соответствующему лицензированному специалисту.",
        cta: "Получить расчёт",
      },
      {
        title: "Приоритетная и экстренная поддержка 24/7",
        tagline: "Срочная многоязычная, административная, документная, переводческая и бизнес-поддержка для клиентов, которые не могут ждать до обычного рабочего времени.",
        price: "От $65 USD/час",
        meta: "Доступно по всему миру, при наличии команды.",
        featured: ["Срочный деловой перевод", "Срочный устный перевод", "Документы в последнюю минуту", "Поддержка в нерабочее время", "Поддержка в выходные и праздники"],
        moreLabel: "Экстренные услуги",
        groups: [
          {
            heading: null,
            items: [
              "Срочный деловой перевод",
              "Срочный деловой устный перевод",
              "Подготовка документов в последнюю минуту",
              "Срочное форматирование документов",              "Срочные презентации",
              "Админподдержка в нерабочее время",
              "Админподдержка в выходные",
              "Поддержка в праздничные дни",
              "Поддержка международных часовых поясов",
              "Срочная коммуникация с клиентами",
              "Срочная многоязычная коммуникация",
              "Экстренная координация совещаний",
              "Срочное планирование",
              "Срочные бизнес-исследования",
              "Экстренная поддержка клиентского сервиса",
            ],
          },
        ],
        pricing: [
          { label: "Приоритетная поддержка", value: "От $45/час" },
          { label: "Поддержка в нерабочее время", value: "От $55/час" },
          { label: "Экстренная поддержка 24/7", value: "От $65/час" },
          { label: "Критическая / ответ до 2 часов", value: "От $75/час" },
          { label: "Экстренная поддержка в большие праздники", value: "От $85/час" },
          { label: "Минимальная стоимость экстренной услуги", value: "$65 USD" },
        ],
        note: "Экстренные услуги и услуги в нерабочее время зависят от доступности. Время ответа подтверждается до оплаты клиентом.",
        cta: "Запросить экстренную поддержку",
      },
    ],
    plans: [
      {
        price: "От $300 USD/мес",
        fit: "Для предпринимателей и профессионалов, которым нужна episodic виртуальная поддержка.",
        features: ["До 10 часов поддержки", "Дополнительные часы доступны за доплату", "Административная поддержка", "Планирование", "Документы", "Поддержка по email"],
        cta: "Заказать пакет Essential",
      },
      {
        price: "От $575 USD/мес",
        fit: "Для бизнесов, которым нужна стабильная еженедельная поддержка.",
        features: ["До 20 часов поддержки", "Дополнительные часы доступны за доплату", "Административная поддержка", "Многоязычная поддержка", "Координация встреч", "Отслеживание проектов", "Приоритетное планирование"],
        cta: "Заказать пакет Professional",
      },
      {
        price: "От $1,100 USD/мес",
        fit: "Для руководителей и бизнесов, которым нужна постоянная поддержка высокого уровня.",
        features: ["До 60 часов поддержки", "Дополнительные часы доступны за доплату", "Администрирование для руководителей", "Многоязычная поддержка клиентов", "Координация встреч и проектов", "Приоритетный ответ", "Выделенная структура поддержки"],
        cta: "Заказать пакет Executive",
      },
      {
        price: "Индивидуальная цена",
        fit: "Для компаний, которым нужна международная, многоязычная, расширенная по времени или высокообъёмная поддержка.",
        features: ["Индивидуальный месячный объём часов", "Дополнительные часы доступны за доплату", "Поддержка на английском, украинском, арабском и других языках", "Приоритетная помощь", "Расширенная доступность по времени", "Льготные экстренные тарифы", "Собственные рабочие процессы", "Несколько категорий услуг", "Выделенная бизнес-поддержка"],
        cta: "Запросить индивидуальный расчёт",
      },
    ],
    steps: [
      { title: "Связь", text: "Запланируйте ознакомительную консультацию и обсудите потребности вашего бизнеса." },
      { title: "Персонализация", text: "Выберите тип и уровень поддержки, который лучше всего вам подходит." },
      { title: "Делегирование", text: "Передайте административные задачи, которые хотите снять с себя." },
      { title: "Фокус", text: "Уделите больше времени клиентам, проектам и росту, пока VCK заботится об административных деталях." },
    ],
    why: [
      { title: "Профессионально и надёжно", text: "Стабильная поддержка, на которую можно планировать." },
      { title: "Гибкая виртуальная поддержка", text: "Поддержка масштабируется под вашу нагрузку — без жёстких контрактов." },
      { title: "Внимание к деталям", text: "Каждая задача выполняется тщательно, проверяется и сдаётся на высоком уровне." },
      { title: "Конфиденциально по умолчанию", text: "Деловая информация обрабатывается со строгой конфиденциальностью и разумными мерами защиты; соглашения о конфиденциальности доступны при необходимости." },
      { title: "Чёткая коммуникация", text: "Профессиональная, оперативная и прозрачная коммуникация на каждом шаге." },
      { title: "Персонализация под вас", text: "Поддержка адаптируется под инструменты, предпочтения и стиль работы каждого клиента." },
      { title: "Без штатного сотрудника", text: "Поддержка высокого уровня без затрат и обязательств найма." },
      { title: "Постоянно или проектно", text: "Доступны как длительная ежемесячная поддержка, так и разовые задачи." },
      { title: "Виртуально по всему миру", text: "Клиенты в Канаде, США, Европе и международно." },
    ],
    clients: ["Предприниматели", "Малый бизнес", "Консультанты", "Руководители", "Профессионалы", "Стартапы", "Независимые подрядчики", "Занятые владельцы бизнеса", "Организации, которым нужна временная админподдержка", "Частные лица", "Новоприбывшие в Канаду", "Иностранные студенты", "Международные семьи", "Профессионалы, переезжающие в Канаду", "Лица с ограниченным знанием английского", "Украиноязычные клиенты", "Арабоязычные клиенты"],
    faqs: [
      { q: "Что такое виртуальный административный ассистент?", a: "Виртуальный административный ассистент — это профессионал, который предоставляет административную, организационную и бизнес-поддержку удалённо. Вы получаете ту же надёжную, качественную помощь, что и от офисного администратора, — без затрат, оборудования и обязательств штатного найма." },
      { q: "Можно ли нанять VCK Business Lab всего на несколько часов?", a: "Да. Поддержка гибка по своей природе. Вы можете привлечь VCK всего на несколько часов episodic помощи, на разовый проект или на краткосрочную задачу — минимальных ежемесячных обязательств нет." },
      { q: "Предлагаете ли вы постоянную ежемесячную поддержку?", a: "Да. Пакеты Professional и Executive обеспечивают регулярную еженедельную и ежемесячную помощь для клиентов, которым нужна стабильная поддержка повседневного администрирования." },
      { q: "Работаете ли вы с международными клиентами?", a: "Безусловно. Все услуги предоставляются на 100% удалённо, поэтому VCK Business Lab поддерживает клиентов в Канаде, США, Европе и международно. Обращения международных клиентов всегда приветствуются." },
      { q: "Берёте ли вы разовые проекты?", a: "Да. Индивидуальные проекты охватывают разовые задачи: форматирование документов, исследования, координацию мероприятий и организацию процессов — каждый с чётким фиксированным расчётом до начала работы." },
      { q: "Как безопасно передать вам документы и информацию?", a: "Документы передаются через безопасные каналы с контролем доступа, например зашифрованное облачное хранилище и платформы обмена файлами. Доступ ограничен только тем, что необходимо для вашего сотрудничества, а соглашения о конфиденциальности всегда доступны по запросу." },
      { q: "С каким программным обеспечением вы работаете?", a: "VCK свободно работает с Microsoft 365 — Word, Excel, Outlook, Teams, PowerPoint, — а также Google Workspace, PDF-инструментами и Acrobat, Zoom и большинством распространённых бизнес-платформ. Если ваш бизнес использует другой инструмент — просто спросите." },
      { q: "Помогаете ли вы с Microsoft Word, Excel, Outlook, Teams и PDF-документами?", a: "Да — это ядро нашей работы: профессиональное форматирование документов Word, таблицы и трекеры Excel, управление почтой и календарём в Outlook, координация встреч в Teams, а также подготовка и форматирование PDF." },
      { q: "Сохраняется ли конфиденциальность моих деловых документов?", a: "Всегда. Конфиденциальное обращение с деловой информацией — учредительный принцип VCK Business Lab. Ваши документы никогда не передаются, не обсуждаются и не используются за пределами вашего сотрудничества, и мы с радостью формализуем это соглашением о неразглашении." },
      { q: "Как работает оплата?", a: "Цены прозрачны и индивидуальны — каждое сотрудничество начинается со стартового тарифа, который уточняется после короткой консультации. Постоянные пакеты выставляются ежемесячно, разовые проекты имеют фиксированный расчёт, а долгосрочные контракты не требуются." },
      { q: "Как оплатить услуги?", a: "После подтверждения ваших требований, объёма и стоимости VCK Business Lab отправит вам защищённую платёжную ссылку напрямую. Инструкции по оплате предоставляются до начала работы или в соответствии с согласованными условиями оплаты — сайт не предлагает публичной страницы оплаты." },
      { q: "Вы работаете с частными лицами и новоприбывшими или только с бизнесами?", a: "С обеими категориями. Наряду с бизнес-услугами VCK предлагает личную поддержку и поддержку новоприбывших — языковую помощь, помощь в общении с банками, страховыми, коммунальными службами, арендодателями и школами, а также повседневную административную поддержку для частных лиц, семей и новоприбывших в Канаду." },
      { q: "Можете ли вы помочь с иммиграционными заявлениями, юридическими вопросами или финансовыми советами?", a: "Нет — и мы заботимся о том, чтобы это было ясно. VCK Business Lab не предоставляет иммиграционных, юридических, финансовых, страховых, налоговых или медицинских советов и не готовит и не подаёт иммиграционные заявления. Наши личные услуги охватывают только коммуникацию, организацию и администрирование. Когда требуется лицензированный или регулируемый специалист, мы всегда скажем об этом и поможем его найти." },
    ],
    testimonials: [
      {
        quote:
          "Working with this team was a smooth and professional experience from start to finish. They created a modern, clear, and user-friendly website for my legal practice in Ukraine that presents my services in a professional way and makes it easy for clients to find the information they need.\n\nThey listened carefully to my requirements, communicated clearly throughout the process, and delivered a website that reflects my work and professional image very well.\n\nI am very satisfied with the result and would gladly recommend their services to other professionals and businesses looking for reliable website and digital support.",
        name: "Anton",
        detail: "Юрист, Украина",
      },
    ],
    loyaltyTiers: [
      { months: "1 месяц", hours: "3 бесплатных часа", note: "Отличный способ начать и почувствовать поддержку VCK с небольшим бонусом от нас.", extras: [] },
      { months: "3 месяца", hours: "8 бесплатных часов", extras: ["Бесплатный приветственный пакет VCK", "Приоритетное планирование", "Гибкая поддержка в подходящих услугах"] },
      { months: "6 месяцев", hours: "18 бесплатных часов", extras: ["Премиальный приветственный пакет VCK", "Приоритетное планирование", "Приоритетное бронирование проектов", "Льготные тарифы на отдельные срочные услуги"] },
      { months: "12 месяцев", hours: "36 бесплатных часов", extras: ["Премиальный приветственный пакет VCK", "Приоритетное планирование", "Приоритетное бронирование проектов", "Льготные экстренные тарифы", "Бесплатная ежегодная сессия планирования поддержки", "Эксклюзивные преимущества постоянного клиента"] },
    ],
    loyaltyServices: ["Виртуальная административная поддержка", "Поддержка руководителей", "Многоязычная поддержка клиентов", "Помощь с документами и проектами", "Переводческие услуги", "Другие подходящие бизнес-услуги VCK"],
    marquee: ["Виртуальная административная поддержка", "Управление календарём руководителя", "Документы и бизнес-поддержка", "Координация встреч", "Координация бизнеса и проектов", "Конфиденциальная поддержка руководителей"],
    comparison: {
      columns: ["Essential", "Professional", "Executive", "Global Priority"],
      rows: [
        { label: "Ежемесячные часы поддержки", values: ["До 10", "До 20", "До 60", "Индивидуально"] },
        { label: "Административная поддержка", values: [true, true, true, true] },
        { label: "Многоязычная поддержка", values: [false, true, true, true] },
        { label: "Координация встреч и проектов", values: [false, true, true, true] },
        { label: "Администрирование для руководителей", values: [false, false, true, true] },
        { label: "Приоритетный ответ и планирование", values: [false, true, true, true] },
        { label: "Расширенная доступность по времени", values: [false, false, false, true] },
        { label: "Льготные экстренные тарифы", values: [false, false, false, true] },
        { label: "Выделенная структура поддержки", values: [false, false, true, true] },
        { label: "Цена", values: ["От $300/мес", "От $575/мес", "От $1,100/мес", "Индивидуально"] },
      ],
    },
    aboutChapters: [
      { title: "Бутик-отличие", text: "VCK сознательно остаётся бутик-компанией. Вы работаете напрямую с выделенным профессионалом, который изучает, как работает ваш бизнес, — а не со сменным пулом анонимных ассистентов. Каждая деталь, предпочтение и стандарт запоминаются и уважаются." },
      { title: "Тихая деликатность", text: "Доверие — фундамент каждого сотрудничества. Конфиденциальная деловая информация обрабатывается бережно, защищается безопасными каналами и никогда не обсуждается за пределами вашей совместной работы." },
      { title: "Бескомпромиссная точность", text: "От идеально отформатированного документа до безупречно скоординированного календаря — стандарт одинаков каждый раз: точно, безупречно и в срок. Детали и есть работа." },
    ],
    aboutValues: [
      { title: "Профессионализм", text: "Безупречный, надёжный стандарт в каждом взаимодействии и каждом результате." },
      { title: "Организованность", text: "Структура и порядок для почтовых ящиков, календарей, файлов и процессов." },
      { title: "Коммуникация", text: "Чётко, оперативно и профессионально — вы всегда знаете, на каком этапе дела." },
      { title: "Клиентский сервис", text: "Внимательная, персональная поддержка, адаптированная под стиль работы каждого клиента." },
    ],
  },
};
